import React from 'react';
import { withSessionSsr, getPublicToken } from "../lib/sessionMiddleware";
import { getCanonicalPath } from "../lib/canonical";
import {
  // Navbar,
  Wrapper,
  SubtituloSeccion,
  Seccion,
  Footer,
  Loader,
  CarouselDeBanners,
  FranjaClientes,
  Container,
  CarouselDeProductosV2,
  // CarouselDeNotas,
  CarouselDeOpinionesV2,
  HeadTags,
  BtnFlotanteWhatsapp,
  ContenedorTematicas,
  FranjaBeneficios,
  TituloSeccion,
  BotonVerTodo,
} from '../components';
import { Navbar } from '../components';
import { useSelector } from 'react-redux';
import { Banner } from '../models/Banner';
import { Producto } from '../models/Producto';
import { Opinion } from '../models/Opinion';
import { StrapiCollectionResponse } from '../models/Strapi';
import styles from './styles.module.scss';

type HomeDataResponse = {
  banners?: StrapiCollectionResponse<Banner['attributes']>
  bannersMarcas?: StrapiCollectionResponse<Banner['attributes']>
  bannersTematicas?: StrapiCollectionResponse<Banner['attributes']>
  novedades?: StrapiCollectionResponse<Producto['attributes']>
  destacados?: StrapiCollectionResponse<Producto['attributes']>
  opiniones?: StrapiCollectionResponse<Opinion['attributes']>
}

type HomePageProps = {
  pageProps: {
    banners: Banner[]
    bannersTematicas: Banner[]
    novedades: Producto[]
    destacados: Producto[]
    bannersMarcas: Banner[]
    opiniones: Opinion[]
    pathname: string
  }
}

const HomePage = (props: HomePageProps) => {

  const bannersPrincipales = props.pageProps.banners;
  const bannersTematicas = props.pageProps.bannersTematicas;
  const novedades = props.pageProps.novedades;
  const destacados = props.pageProps.destacados;
  const bannersMarcas = props.pageProps.bannersMarcas;
  const opiniones = props.pageProps.opiniones;
  // const notas = props.pageProps.notas

  return (<>

    <HeadTags
      title=""
      description="Festejá tus eventos y fiestas con nuestros diseños innovadores realizados artesanalmente. Tenemos muchas categorías para decorarle a los que más querés!"
      path={props.pageProps.pathname}
    />

    <Navbar />

    <Seccion padding="0px">
      <Wrapper>
        <CarouselDeBanners
          data={bannersPrincipales}
          aspectRatioDesktop="1920 / 480"
          aspectRatioMobile="768 / 384"
          autoplay={{ delay: 3000 }}
          spaceBetween={20}
          slidesPerView={1}
          slidesPerGroup={1}
          loop={bannersPrincipales?.length > 1}
          navigation={bannersPrincipales?.length > 1}
          pagination={{ clickable: true }}
          priority
        />
      </Wrapper>
    </Seccion>

    <Seccion padding="38px 20px" color="#f5f5f5">
      <Container width="600px">
        <h1 className={styles.title}>Las celebraciones duran un momento.<br />Los recuerdos, toda la vida</h1>
        <p className={styles.subtexto}>En <strong>We Celebrate</strong> diseñamos cada detalle para transformar esos momentos <em>únicos</em> en recuerdos que siempre van a hacer <em>sonreír</em>. </p><p className={`${styles.subtexto} ${styles.desktopOnly}`}>Creamos colecciones <em>originales</em> para que celebrar sea tan lindo como recordarlo. ✨</p>
      </Container>
      {/* <FranjaBeneficios /> */}
    </Seccion>

    <Seccion padding="20px">
      <Wrapper>
        {bannersTematicas?.length > 0 && <>
          <SubtituloSeccion align="center">Inspirate con nuestras ideas</SubtituloSeccion>
          <br />
          <CarouselDeBanners
            data={bannersTematicas}
            aspectRatioDesktop="558 / 702"
            aspectRatioMobile="558 / 702"
            autoplay={{ delay: 6000 }}
            spaceBetween={20}
            slidesPerView={2}
            slidesPerGroup={2}
            breakpoints={{ 700: { slidesPerView: 4, slidesPerGroup: 4 } }}
            loop={bannersTematicas?.length > 1 ? true : false}
            navigation={bannersTematicas?.length > 1 ? true : false}
            pagination={{ clickable: true }}
          />
        </>}

        <BotonVerTodo href="/tematicas">Ver todas las temáticas</BotonVerTodo>

      </Wrapper>
    </Seccion>

    <br />

    <Seccion padding="20px 20px" color="#fff">
      <Wrapper>
        {novedades?.length > 0 && <>
          <SubtituloSeccion align="center">Descubrí nuestras novedades</SubtituloSeccion>
          <br />
          <CarouselDeProductosV2
            data={novedades}
            spaceBetween={4}
            slidesPerView={2}
            slidesPerGroup={2}
            loop={true}
            rows={2}
            breakpoints={{ 700: { slidesPerView: 4, slidesPerGroup: 4, grid: { rows: 1 } } }}
            navigation={false}
            pagination={{ clickable: true }}
          />
          <BotonVerTodo href="/tienda?novedad=1">Ver todas las novedades</BotonVerTodo>
        </>}

      </Wrapper>
    </Seccion>

    <br />

    <Seccion padding="20px 20px" color="#fff">
      <Wrapper>
        {destacados?.length > 0 && <>
          <SubtituloSeccion align="center">Los más elegidos</SubtituloSeccion>
          <br />
          <CarouselDeProductosV2
            data={destacados}
            spaceBetween={4}
            slidesPerView={2}
            slidesPerGroup={2}
            loop={true}
            rows={2}
            breakpoints={{ 700: { slidesPerView: 4, slidesPerGroup: 4, grid: { rows: 1 } } }}
            navigation={false}
            pagination={{ clickable: true }}
          />
          <BotonVerTodo href="/tienda?destacado=1">Ver todos los destacados</BotonVerTodo>
        </>}

      </Wrapper>
    </Seccion>

    <br />

    {/* <div className={styles.desktopOnly}>
      <Seccion padding="20px" style={{ textAlign: "center" }}>
        <Container width="1200px">
          <ContenedorTematicas />
        </Container>
      </Seccion>
      <br />
    </div>

    <br /> */}

    <Seccion padding="20px">
      <Wrapper>
        <SubtituloSeccion align="center">Lo que opinan nuestros clientes</SubtituloSeccion>
        <br />
        <CarouselDeOpinionesV2
          data={opiniones}
          autoplay={{ delay: 6000 }}
          spaceBetween={20}
          slidesPerView={1}
          slidesPerGroup={1}
          breakpoints={{ 700: { slidesPerView: 4, slidesPerGroup: 4 } }}
          loop={true}
          navigation={false}
          pagination={{ clickable: true }}
        />
      </Wrapper>
    </Seccion>

    <br />

    <Seccion padding="20px" color="#f5f5f5">
      <Wrapper>
        <SubtituloSeccion align="center">Confían en nosotros</SubtituloSeccion>
        <br />
        <FranjaClientes
          data={bannersMarcas}
        />
      </Wrapper>
    </Seccion>

    <Footer />

    <BtnFlotanteWhatsapp />
  </>);
};

export default HomePage;

export const getServerSideProps = withSessionSsr(
  async function getServerSideProps(ctx) {

    const { req } = ctx;

    const publicToken = await getPublicToken(req);

    const fetchHomeData = async () => {
      try {
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/home/get-data`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET
          },
        });
        const data: HomeDataResponse = await result.json();
        return {
          banners: data?.banners?.data || [],
          bannersMarcas: data?.bannersMarcas?.data || [],
          bannersTematicas: data?.bannersTematicas?.data || [],
          novedades: data?.novedades?.data || [],
          destacados: data?.destacados?.data || [],
          opiniones: data?.opiniones?.data || [],
        };
      } catch (err) {
        console.log("e", err);
        return {
          banners: [],
          bannersMarcas: [],
          bannersTematicas: [],
          novedades: [],
          destacados: [],
          opiniones: [],
        };
      }
    };

    const { banners, bannersMarcas, bannersTematicas, novedades, destacados, opiniones } = await fetchHomeData();

    return {
      props: {
        banners: banners,
        bannersTematicas: bannersTematicas,
        novedades: novedades,
        destacados: destacados,
        bannersMarcas: bannersMarcas,
        opiniones: opiniones,
        pathname: getCanonicalPath(req),
      },
    };

  },
);